import { useQuery } from "react-query";
import { getRoles } from "../services/user/getRoles";
import { PagedRequestType } from "../types/PagedResults";

export const useGetRolesQuery = (data: PagedRequestType) =>
  useQuery(
    ["roles-pagination", JSON.stringify(data)],
    () => getRoles(data)
  );